<template lang='pug'>
.level-wrapper
    .base-title {{ name }}
    .list-wrapper(v-if='Array.isArray(levelGroup)')
        .item(@click='jumpTo(item)', v-for='item in levelGroup')
            .title {{ item.detail.name }}
            van-icon(name='arrow', color='#64a7b1')
    van-collapse(v-model='activeLevel', v-else)
        van-collapse-item(
            :title='k',
            v-for='(level2, k) in levelGroup',
            :key='k'
            :name='k',
            @click.native.stop='onCollapseChange(level2)'
        )
            .name(v-for='item in level2', :key='item.id' @click='jumpTo(item)') 
                span {{ item.detail.name }}
                van-icon(name='arrow')
</template>

<script>
import dataDic from '@/assets/data/dic'
import { getDataRow } from '@custouch/proxy-use'
export default {
    // props: ['section', 'label', 'name', 'index'],
    props: ['rId', 'name'],
    data() {
        return {
            list: [],
            levelGroup: {},
            activeLevel: [],
        }
    },
    methods: {
        jumpTo(item) {
            if (item.detail.link) {
                window.location.href = item.detail.link
            } else {
                // this.$router.push({ name: "productDetail", params: { section: this.section, name: item.name }, query: { index: this.index } })
                this.$router.push({ name: "productDetail", params: {rId: item.id} })
            }
        },
        onCollapseChange(level2) {
            if (level2.length === 1) {
                this.jumpTo(level2[0])
            }

        },
    },
    async created() {
        const { DATA } = window.env
        const { template } = DATA
        const ret = await getDataRow({dataRowId: this.rId})
        if(ret.dataRows.length){
            this.list = ret.dataRows.filter(item=>item.dataTemplateId === template.productCase && item.detail.caseTitle === this.name)
            const levelGroup = this.list.reduce((pre,cur)=>{
                if(cur.detail.level1){
                    if(pre[cur.detail.level1]){
                        pre[cur.detail.level1].push(cur)
                    }else{
                        pre[cur.detail.level1] = [cur]
                    }
                }
                return pre
            },{})
            if(levelGroup && Object.keys(levelGroup).length > 0){
                this.levelGroup = levelGroup
            }else{
                this.levelGroup = this.list
            }
        }
        this.$root.$emit('pageview',{
            title: ret.detail.name
        })
        // const list = await this.$store.dispatch('getJson', dataDic[this.section])
        // if (this.label && this.name) {
        //     this.list = list.filter(item => item.index === this.index && item[this.label] === this.name)
        // } else {
        //     this.list = list
        // }
        // const levelGroup = this.list.reduce((pre, cur) => {
        //     if (cur.level1) {
        //         if (pre[cur.level1]) {
        //             pre[cur.level1].push(cur)
        //         } else {
        //             pre[cur.level1] = [cur]
        //         }
        //     }
        //     return pre
        // }, {})
        // if (levelGroup && Object.keys(levelGroup).length > 0) {
        //     this.levelGroup = levelGroup
        // } else {
        //     this.levelGroup = this.list
        // }
    }
}
</script>

<style scoped lang='less'>
.level-wrapper {
    padding: 0 0.8rem;
    .list-wrapper {
        .item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid #f2f2f2;
            line-height: 1.9rem;
        }
    }
    .name {
        line-height: 1.9rem;
        &:not(:last-child) {
            border-bottom: 1px solid #f2f2f2;
        }
    }
    /deep/.van-cell__title,
    /deep/.van-cell__right-icon {
        color: #64a7b1;
    }
    .name {
        display: flex;
        justify-content: space-between;
        align-items: center;
        i {
            color: #64a7b1;
        }
    }
}
</style>